import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReturnButton from '../../components/ui/ReturnButton';
import CategoryList from './sections/CategoryList';
import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';

const CategoryChoicePage = () => {
  const [locationsCategories, setLocationsCategories] = useState([]);
  const [routesCategories, setRoutesCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { type } = useParams();
  const navigate = useNavigate();

  const getPageConfig = () => {
    switch(type) {
      case 'routes':
        return { title: 'МАРШРУТЫ' };
      case 'locations':
      default:
        return { title: 'ЛОКАЦИИ' };
    }
  };

  const pageConfig = getPageConfig();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const apiUrl = process.env.REACT_APP_API_URL;
        
        const [locationsRes, routesRes] = await Promise.all([
          fetch(`${apiUrl}/categories/type/locations`),
          fetch(`${apiUrl}/categories/type/routes`)
        ]);

        if (!locationsRes.ok || !routesRes.ok) {
          throw new Error('Ошибка загрузки категорий');
        }

        const locationsData = await locationsRes.json();
        const routesData = await routesRes.json();

        // Убираем обёртку .data — теперь API возвращает массив напрямую
        setLocationsCategories(Array.isArray(locationsData) ? locationsData : []);
        setRoutesCategories(Array.isArray(routesData) ? routesData : []);
        
        console.log('Загружено локаций:', locationsData.length);
        console.log('Загружено маршрутов:', routesData.length);

      } catch (err) {
        console.error('Ошибка:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const currentCategories = useMemo(() => {
    const categories = type === 'routes' ? routesCategories : locationsCategories;
    console.log(`Категории для ${type}:`, categories);
    return categories;
  }, [type, routesCategories, locationsCategories]);

  const handleReturn = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div id="tagChoicePageContainer" className="flex-column">
        <Header />
        <div style={{ textAlign: 'center', padding: '50px' }}>
          Загрузка категорий...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="tagChoicePageContainer" className="flex-column">
        <Header />
        <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
          Ошибка: {error}
        </div>
      </div>
    );
  }

  return (
    <div id="tagChoicePageContainer" className="flex-column">
      <Header />
      <ReturnButton 
        onClick={handleReturn}
        text="Назад"
        className="category-return-btn"
      />
      
      <div className="category-header">
        <h1 className="tagChoicePageName">
          {pageConfig.title}
        </h1>
      </div>
      
      <CategoryList 
        categories={currentCategories} 
        type={type}
      />
      <Footer />
    </div>
  );
};

export default CategoryChoicePage;